import _isEmpty from "lodash/isEmpty";
var _excluded = ["fontSize", "label", "subtitle", "errorMessage", "invalid", "decimalPlaces", "delay", "value", "onChange", "type", "unboundedWidth", "orientation", "min", "max", "customEmailValidityCheck", "labelStyles", "disabled", "helperText", "maxLength", "required", "placeholder", "analyticsName"],
    _excluded2 = ["suggestion", "useSuggestion"];

function cov_ndg0d3lom() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Input.tsx";
  var hash = "7597c3fd6986d867cfc66edf73785ba8987d9044";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 30
        },
        end: {
          line: 20,
          column: 59
        }
      },
      "1": {
        start: {
          line: 143,
          column: 43
        },
        end: {
          line: 401,
          column: 1
        }
      },
      "2": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 169,
          column: 80
        }
      },
      "3": {
        start: {
          line: 170,
          column: 35
        },
        end: {
          line: 172,
          column: 3
        }
      },
      "4": {
        start: {
          line: 174,
          column: 46
        },
        end: {
          line: 174,
          column: 70
        }
      },
      "5": {
        start: {
          line: 175,
          column: 33
        },
        end: {
          line: 175,
          column: 64
        }
      },
      "6": {
        start: {
          line: 176,
          column: 38
        },
        end: {
          line: 176,
          column: 62
        }
      },
      "7": {
        start: {
          line: 177,
          column: 32
        },
        end: {
          line: 177,
          column: 68
        }
      },
      "8": {
        start: {
          line: 178,
          column: 44
        },
        end: {
          line: 178,
          column: 74
        }
      },
      "9": {
        start: {
          line: 179,
          column: 30
        },
        end: {
          line: 190,
          column: 3
        }
      },
      "10": {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 187,
          column: 7
        }
      },
      "11": {
        start: {
          line: 182,
          column: 33
        },
        end: {
          line: 182,
          column: 57
        }
      },
      "12": {
        start: {
          line: 183,
          column: 38
        },
        end: {
          line: 183,
          column: 62
        }
      },
      "13": {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 184,
          column: 27
        }
      },
      "14": {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 185,
          column: 34
        }
      },
      "15": {
        start: {
          line: 186,
          column: 8
        },
        end: {
          line: 186,
          column: 45
        }
      },
      "16": {
        start: {
          line: 191,
          column: 19
        },
        end: {
          line: 191,
          column: 51
        }
      },
      "17": {
        start: {
          line: 192,
          column: 21
        },
        end: {
          line: 192,
          column: 93
        }
      },
      "18": {
        start: {
          line: 194,
          column: 23
        },
        end: {
          line: 194,
          column: 94
        }
      },
      "19": {
        start: {
          line: 195,
          column: 34
        },
        end: {
          line: 195,
          column: 62
        }
      },
      "20": {
        start: {
          line: 197,
          column: 24
        },
        end: {
          line: 201,
          column: 3
        }
      },
      "21": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 198,
          column: 30
        }
      },
      "22": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 199,
          column: 45
        }
      },
      "23": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 29
        }
      },
      "24": {
        start: {
          line: 203,
          column: 24
        },
        end: {
          line: 229,
          column: 3
        }
      },
      "25": {
        start: {
          line: 206,
          column: 16
        },
        end: {
          line: 206,
          column: 20
        }
      },
      "26": {
        start: {
          line: 207,
          column: 21
        },
        end: {
          line: 207,
          column: 23
        }
      },
      "27": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 227,
          column: 5
        }
      },
      "28": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 24
        }
      },
      "29": {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 226,
          column: 7
        }
      },
      "30": {
        start: {
          line: 215,
          column: 38
        },
        end: {
          line: 215,
          column: 64
        }
      },
      "31": {
        start: {
          line: 216,
          column: 10
        },
        end: {
          line: 216,
          column: 44
        }
      },
      "32": {
        start: {
          line: 217,
          column: 10
        },
        end: {
          line: 217,
          column: 54
        }
      },
      "33": {
        start: {
          line: 218,
          column: 10
        },
        end: {
          line: 218,
          column: 16
        }
      },
      "34": {
        start: {
          line: 220,
          column: 10
        },
        end: {
          line: 220,
          column: 45
        }
      },
      "35": {
        start: {
          line: 221,
          column: 10
        },
        end: {
          line: 221,
          column: 16
        }
      },
      "36": {
        start: {
          line: 223,
          column: 10
        },
        end: {
          line: 223,
          column: 58
        }
      },
      "37": {
        start: {
          line: 224,
          column: 10
        },
        end: {
          line: 224,
          column: 16
        }
      },
      "38": {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 33
        }
      },
      "39": {
        start: {
          line: 232,
          column: 23
        },
        end: {
          line: 245,
          column: 3
        }
      },
      "40": {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 244,
          column: 5
        }
      },
      "41": {
        start: {
          line: 235,
          column: 8
        },
        end: {
          line: 235,
          column: 23
        }
      },
      "42": {
        start: {
          line: 237,
          column: 8
        },
        end: {
          line: 237,
          column: 21
        }
      },
      "43": {
        start: {
          line: 241,
          column: 8
        },
        end: {
          line: 241,
          column: 57
        }
      },
      "44": {
        start: {
          line: 243,
          column: 8
        },
        end: {
          line: 243,
          column: 22
        }
      },
      "45": {
        start: {
          line: 247,
          column: 18
        },
        end: {
          line: 270,
          column: 3
        }
      },
      "46": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 269,
          column: 5
        }
      },
      "47": {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 26
        }
      },
      "48": {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 23
        }
      },
      "49": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 21
        }
      },
      "50": {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 22
        }
      },
      "51": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 262,
          column: 22
        }
      },
      "52": {
        start: {
          line: 266,
          column: 8
        },
        end: {
          line: 266,
          column: 22
        }
      },
      "53": {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 268,
          column: 22
        }
      },
      "54": {
        start: {
          line: 272,
          column: 25
        },
        end: {
          line: 285,
          column: 3
        }
      },
      "55": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 284,
          column: 5
        }
      },
      "56": {
        start: {
          line: 275,
          column: 8
        },
        end: {
          line: 275,
          column: 33
        }
      },
      "57": {
        start: {
          line: 277,
          column: 8
        },
        end: {
          line: 277,
          column: 32
        }
      },
      "58": {
        start: {
          line: 279,
          column: 8
        },
        end: {
          line: 279,
          column: 23
        }
      },
      "59": {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 281,
          column: 23
        }
      },
      "60": {
        start: {
          line: 283,
          column: 8
        },
        end: {
          line: 283,
          column: 18
        }
      },
      "61": {
        start: {
          line: 287,
          column: 35
        },
        end: {
          line: 296,
          column: 3
        }
      },
      "62": {
        start: {
          line: 288,
          column: 4
        },
        end: {
          line: 295,
          column: 5
        }
      },
      "63": {
        start: {
          line: 290,
          column: 8
        },
        end: {
          line: 290,
          column: 23
        }
      },
      "64": {
        start: {
          line: 292,
          column: 8
        },
        end: {
          line: 292,
          column: 21
        }
      },
      "65": {
        start: {
          line: 294,
          column: 8
        },
        end: {
          line: 294,
          column: 25
        }
      },
      "66": {
        start: {
          line: 302,
          column: 2
        },
        end: {
          line: 306,
          column: 23
        }
      },
      "67": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 305,
          column: 5
        }
      },
      "68": {
        start: {
          line: 304,
          column: 6
        },
        end: {
          line: 304,
          column: 73
        }
      },
      "69": {
        start: {
          line: 308,
          column: 31
        },
        end: {
          line: 314,
          column: 3
        }
      },
      "70": {
        start: {
          line: 309,
          column: 22
        },
        end: {
          line: 309,
          column: 62
        }
      },
      "71": {
        start: {
          line: 310,
          column: 27
        },
        end: {
          line: 310,
          column: 58
        }
      },
      "72": {
        start: {
          line: 311,
          column: 30
        },
        end: {
          line: 311,
          column: 61
        }
      },
      "73": {
        start: {
          line: 312,
          column: 4
        },
        end: {
          line: 312,
          column: 69
        }
      },
      "74": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 29
        }
      },
      "75": {
        start: {
          line: 316,
          column: 23
        },
        end: {
          line: 329,
          column: 3
        }
      },
      "76": {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 317,
          column: 23
        }
      },
      "77": {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 318,
          column: 27
        }
      },
      "78": {
        start: {
          line: 319,
          column: 4
        },
        end: {
          line: 319,
          column: 48
        }
      },
      "79": {
        start: {
          line: 320,
          column: 4
        },
        end: {
          line: 320,
          column: 32
        }
      },
      "80": {
        start: {
          line: 321,
          column: 4
        },
        end: {
          line: 328,
          column: 5
        }
      },
      "81": {
        start: {
          line: 324,
          column: 8
        },
        end: {
          line: 324,
          column: 84
        }
      },
      "82": {
        start: {
          line: 325,
          column: 8
        },
        end: {
          line: 325,
          column: 14
        }
      },
      "83": {
        start: {
          line: 327,
          column: 8
        },
        end: {
          line: 327,
          column: 45
        }
      },
      "84": {
        start: {
          line: 331,
          column: 21
        },
        end: {
          line: 334,
          column: 3
        }
      },
      "85": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 332,
          column: 27
        }
      },
      "86": {
        start: {
          line: 333,
          column: 4
        },
        end: {
          line: 333,
          column: 61
        }
      },
      "87": {
        start: {
          line: 337,
          column: 25
        },
        end: {
          line: 337,
          column: 83
        }
      },
      "88": {
        start: {
          line: 339,
          column: 2
        },
        end: {
          line: 400,
          column: 4
        }
      },
      "89": {
        start: {
          line: 403,
          column: 38
        },
        end: {
          line: 405,
          column: 1
        }
      },
      "90": {
        start: {
          line: 404,
          column: 2
        },
        end: {
          line: 404,
          column: 87
        }
      },
      "91": {
        start: {
          line: 407,
          column: 38
        },
        end: {
          line: 407,
          column: 96
        }
      },
      "92": {
        start: {
          line: 407,
          column: 49
        },
        end: {
          line: 407,
          column: 96
        }
      },
      "93": {
        start: {
          line: 414,
          column: 4
        },
        end: {
          line: 426,
          column: 1
        }
      },
      "94": {
        start: {
          line: 415,
          column: 2
        },
        end: {
          line: 425,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 143,
            column: 43
          },
          end: {
            line: 143,
            column: 44
          }
        },
        loc: {
          start: {
            line: 167,
            column: 6
          },
          end: {
            line: 401,
            column: 1
          }
        },
        line: 167
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 5
          }
        },
        loc: {
          start: {
            line: 180,
            column: 69
          },
          end: {
            line: 188,
            column: 5
          }
        },
        line: 180
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 197,
            column: 24
          },
          end: {
            line: 197,
            column: 25
          }
        },
        loc: {
          start: {
            line: 197,
            column: 30
          },
          end: {
            line: 201,
            column: 3
          }
        },
        line: 197
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 203,
            column: 24
          },
          end: {
            line: 203,
            column: 25
          }
        },
        loc: {
          start: {
            line: 205,
            column: 56
          },
          end: {
            line: 229,
            column: 3
          }
        },
        line: 205
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 232,
            column: 23
          },
          end: {
            line: 232,
            column: 24
          }
        },
        loc: {
          start: {
            line: 232,
            column: 29
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 232
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 247,
            column: 18
          },
          end: {
            line: 247,
            column: 19
          }
        },
        loc: {
          start: {
            line: 247,
            column: 24
          },
          end: {
            line: 270,
            column: 3
          }
        },
        line: 247
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 272,
            column: 25
          },
          end: {
            line: 272,
            column: 26
          }
        },
        loc: {
          start: {
            line: 272,
            column: 31
          },
          end: {
            line: 285,
            column: 3
          }
        },
        line: 272
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 287,
            column: 35
          },
          end: {
            line: 287,
            column: 36
          }
        },
        loc: {
          start: {
            line: 287,
            column: 87
          },
          end: {
            line: 296,
            column: 3
          }
        },
        line: 287
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 302,
            column: 12
          },
          end: {
            line: 302,
            column: 13
          }
        },
        loc: {
          start: {
            line: 302,
            column: 18
          },
          end: {
            line: 306,
            column: 3
          }
        },
        line: 302
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 308,
            column: 31
          },
          end: {
            line: 308,
            column: 32
          }
        },
        loc: {
          start: {
            line: 308,
            column: 74
          },
          end: {
            line: 314,
            column: 3
          }
        },
        line: 308
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 316,
            column: 23
          },
          end: {
            line: 316,
            column: 24
          }
        },
        loc: {
          start: {
            line: 316,
            column: 67
          },
          end: {
            line: 329,
            column: 3
          }
        },
        line: 316
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 331,
            column: 21
          },
          end: {
            line: 331,
            column: 22
          }
        },
        loc: {
          start: {
            line: 331,
            column: 27
          },
          end: {
            line: 334,
            column: 3
          }
        },
        line: 331
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 403,
            column: 38
          },
          end: {
            line: 403,
            column: 39
          }
        },
        loc: {
          start: {
            line: 404,
            column: 2
          },
          end: {
            line: 404,
            column: 87
          }
        },
        line: 404
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 407,
            column: 38
          },
          end: {
            line: 407,
            column: 39
          }
        },
        loc: {
          start: {
            line: 407,
            column: 49
          },
          end: {
            line: 407,
            column: 96
          }
        },
        line: 407
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 414,
            column: 4
          },
          end: {
            line: 414,
            column: 5
          }
        },
        loc: {
          start: {
            line: 415,
            column: 2
          },
          end: {
            line: 425,
            column: 9
          }
        },
        line: 415
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 144,
            column: 13
          },
          end: {
            line: 144,
            column: 17
          }
        }],
        line: 144
      },
      "1": {
        loc: {
          start: {
            line: 150,
            column: 2
          },
          end: {
            line: 150,
            column: 13
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 150,
            column: 10
          },
          end: {
            line: 150,
            column: 13
          }
        }],
        line: 150
      },
      "2": {
        loc: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 153,
            column: 9
          },
          end: {
            line: 153,
            column: 15
          }
        }],
        line: 153
      },
      "3": {
        loc: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 154,
            column: 19
          },
          end: {
            line: 154,
            column: 24
          }
        }],
        line: 154
      },
      "4": {
        loc: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 155,
            column: 16
          },
          end: {
            line: 155,
            column: 26
          }
        }],
        line: 155
      },
      "5": {
        loc: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 169,
            column: 56
          },
          end: {
            line: 169,
            column: 76
          }
        }, {
          start: {
            line: 169,
            column: 79
          },
          end: {
            line: 169,
            column: 80
          }
        }],
        line: 169
      },
      "6": {
        loc: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 24
          }
        }, {
          start: {
            line: 169,
            column: 28
          },
          end: {
            line: 169,
            column: 53
          }
        }],
        line: 169
      },
      "7": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 171,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 171,
            column: 51
          }
        }, {
          start: {
            line: 171,
            column: 54
          },
          end: {
            line: 171,
            column: 56
          }
        }],
        line: 171
      },
      "8": {
        loc: {
          start: {
            line: 181,
            column: 6
          },
          end: {
            line: 187,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 6
          },
          end: {
            line: 187,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "9": {
        loc: {
          start: {
            line: 192,
            column: 21
          },
          end: {
            line: 192,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 192,
            column: 48
          },
          end: {
            line: 192,
            column: 72
          }
        }, {
          start: {
            line: 192,
            column: 75
          },
          end: {
            line: 192,
            column: 93
          }
        }],
        line: 192
      },
      "10": {
        loc: {
          start: {
            line: 194,
            column: 23
          },
          end: {
            line: 194,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 194,
            column: 54
          },
          end: {
            line: 194,
            column: 75
          }
        }, {
          start: {
            line: 194,
            column: 78
          },
          end: {
            line: 194,
            column: 94
          }
        }],
        line: 194
      },
      "11": {
        loc: {
          start: {
            line: 194,
            column: 23
          },
          end: {
            line: 194,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 194,
            column: 23
          },
          end: {
            line: 194,
            column: 31
          }
        }, {
          start: {
            line: 194,
            column: 35
          },
          end: {
            line: 194,
            column: 51
          }
        }],
        line: 194
      },
      "12": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        }, {
          start: {
            line: 211,
            column: 11
          },
          end: {
            line: 227,
            column: 5
          }
        }],
        line: 209
      },
      "13": {
        loc: {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 226,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 218,
            column: 16
          }
        }, {
          start: {
            line: 219,
            column: 8
          },
          end: {
            line: 221,
            column: 16
          }
        }, {
          start: {
            line: 222,
            column: 8
          },
          end: {
            line: 224,
            column: 16
          }
        }, {
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 225,
            column: 16
          }
        }],
        line: 212
      },
      "14": {
        loc: {
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 234,
            column: 6
          },
          end: {
            line: 235,
            column: 23
          }
        }, {
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 237,
            column: 21
          }
        }, {
          start: {
            line: 238,
            column: 6
          },
          end: {
            line: 238,
            column: 21
          }
        }, {
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 239,
            column: 20
          }
        }, {
          start: {
            line: 240,
            column: 6
          },
          end: {
            line: 241,
            column: 57
          }
        }, {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 243,
            column: 22
          }
        }],
        line: 233
      },
      "15": {
        loc: {
          start: {
            line: 241,
            column: 15
          },
          end: {
            line: 241,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 241,
            column: 35
          },
          end: {
            line: 241,
            column: 44
          }
        }, {
          start: {
            line: 241,
            column: 47
          },
          end: {
            line: 241,
            column: 56
          }
        }],
        line: 241
      },
      "16": {
        loc: {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 269,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 250,
            column: 26
          }
        }, {
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 252,
            column: 23
          }
        }, {
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 254,
            column: 21
          }
        }, {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 258,
            column: 22
          }
        }, {
          start: {
            line: 259,
            column: 6
          },
          end: {
            line: 262,
            column: 22
          }
        }, {
          start: {
            line: 263,
            column: 6
          },
          end: {
            line: 266,
            column: 22
          }
        }, {
          start: {
            line: 267,
            column: 6
          },
          end: {
            line: 268,
            column: 22
          }
        }],
        line: 248
      },
      "17": {
        loc: {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 284,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 274,
            column: 6
          },
          end: {
            line: 275,
            column: 33
          }
        }, {
          start: {
            line: 276,
            column: 6
          },
          end: {
            line: 277,
            column: 32
          }
        }, {
          start: {
            line: 278,
            column: 6
          },
          end: {
            line: 279,
            column: 23
          }
        }, {
          start: {
            line: 280,
            column: 6
          },
          end: {
            line: 281,
            column: 23
          }
        }, {
          start: {
            line: 282,
            column: 6
          },
          end: {
            line: 283,
            column: 18
          }
        }],
        line: 273
      },
      "18": {
        loc: {
          start: {
            line: 288,
            column: 4
          },
          end: {
            line: 295,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 289,
            column: 6
          },
          end: {
            line: 290,
            column: 23
          }
        }, {
          start: {
            line: 291,
            column: 6
          },
          end: {
            line: 292,
            column: 21
          }
        }, {
          start: {
            line: 293,
            column: 6
          },
          end: {
            line: 294,
            column: 25
          }
        }],
        line: 288
      },
      "19": {
        loc: {
          start: {
            line: 303,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 303,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 303
      },
      "20": {
        loc: {
          start: {
            line: 303,
            column: 8
          },
          end: {
            line: 303,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 303,
            column: 8
          },
          end: {
            line: 303,
            column: 24
          }
        }, {
          start: {
            line: 303,
            column: 28
          },
          end: {
            line: 303,
            column: 56
          }
        }],
        line: 303
      },
      "21": {
        loc: {
          start: {
            line: 312,
            column: 22
          },
          end: {
            line: 312,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 312,
            column: 46
          },
          end: {
            line: 312,
            column: 63
          }
        }, {
          start: {
            line: 312,
            column: 66
          },
          end: {
            line: 312,
            column: 67
          }
        }],
        line: 312
      },
      "22": {
        loc: {
          start: {
            line: 321,
            column: 4
          },
          end: {
            line: 328,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 322,
            column: 6
          },
          end: {
            line: 322,
            column: 20
          }
        }, {
          start: {
            line: 323,
            column: 6
          },
          end: {
            line: 325,
            column: 14
          }
        }, {
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 327,
            column: 45
          }
        }],
        line: 321
      },
      "23": {
        loc: {
          start: {
            line: 337,
            column: 25
          },
          end: {
            line: 337,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 337,
            column: 26
          },
          end: {
            line: 337,
            column: 34
          }
        }, {
          start: {
            line: 337,
            column: 38
          },
          end: {
            line: 337,
            column: 54
          }
        }, {
          start: {
            line: 337,
            column: 58
          },
          end: {
            line: 337,
            column: 71
          }
        }, {
          start: {
            line: 337,
            column: 76
          },
          end: {
            line: 337,
            column: 83
          }
        }],
        line: 337
      },
      "24": {
        loc: {
          start: {
            line: 342,
            column: 21
          },
          end: {
            line: 342,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 342,
            column: 47
          },
          end: {
            line: 342,
            column: 52
          }
        }, {
          start: {
            line: 342,
            column: 55
          },
          end: {
            line: 342,
            column: 63
          }
        }],
        line: 342
      },
      "25": {
        loc: {
          start: {
            line: 343,
            column: 18
          },
          end: {
            line: 343,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 343,
            column: 44
          },
          end: {
            line: 343,
            column: 52
          }
        }, {
          start: {
            line: 343,
            column: 55
          },
          end: {
            line: 343,
            column: 57
          }
        }],
        line: 343
      },
      "26": {
        loc: {
          start: {
            line: 344,
            column: 28
          },
          end: {
            line: 344,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 344,
            column: 45
          },
          end: {
            line: 344,
            column: 51
          }
        }, {
          start: {
            line: 344,
            column: 54
          },
          end: {
            line: 344,
            column: 61
          }
        }],
        line: 344
      },
      "27": {
        loc: {
          start: {
            line: 346,
            column: 7
          },
          end: {
            line: 371,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 346,
            column: 8
          },
          end: {
            line: 346,
            column: 13
          }
        }, {
          start: {
            line: 346,
            column: 17
          },
          end: {
            line: 346,
            column: 25
          }
        }, {
          start: {
            line: 347,
            column: 8
          },
          end: {
            line: 370,
            column: 15
          }
        }],
        line: 346
      },
      "28": {
        loc: {
          start: {
            line: 351,
            column: 14
          },
          end: {
            line: 351,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 351,
            column: 40
          },
          end: {
            line: 351,
            column: 46
          }
        }, {
          start: {
            line: 351,
            column: 49
          },
          end: {
            line: 351,
            column: 51
          }
        }],
        line: 351
      },
      "29": {
        loc: {
          start: {
            line: 352,
            column: 14
          },
          end: {
            line: 352,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 352,
            column: 40
          },
          end: {
            line: 352,
            column: 42
          }
        }, {
          start: {
            line: 352,
            column: 45
          },
          end: {
            line: 352,
            column: 51
          }
        }],
        line: 352
      },
      "30": {
        loc: {
          start: {
            line: 354,
            column: 11
          },
          end: {
            line: 364,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 354,
            column: 11
          },
          end: {
            line: 354,
            column: 16
          }
        }, {
          start: {
            line: 355,
            column: 12
          },
          end: {
            line: 363,
            column: 20
          }
        }],
        line: 354
      },
      "31": {
        loc: {
          start: {
            line: 359,
            column: 21
          },
          end: {
            line: 359,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 359,
            column: 32
          },
          end: {
            line: 359,
            column: 44
          }
        }, {
          start: {
            line: 359,
            column: 47
          },
          end: {
            line: 359,
            column: 56
          }
        }],
        line: 359
      },
      "32": {
        loc: {
          start: {
            line: 365,
            column: 11
          },
          end: {
            line: 369,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 365,
            column: 11
          },
          end: {
            line: 365,
            column: 19
          }
        }, {
          start: {
            line: 366,
            column: 12
          },
          end: {
            line: 368,
            column: 19
          }
        }],
        line: 365
      },
      "33": {
        loc: {
          start: {
            line: 367,
            column: 31
          },
          end: {
            line: 367,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 367,
            column: 42
          },
          end: {
            line: 367,
            column: 54
          }
        }, {
          start: {
            line: 367,
            column: 57
          },
          end: {
            line: 367,
            column: 70
          }
        }],
        line: 367
      },
      "34": {
        loc: {
          start: {
            line: 386,
            column: 21
          },
          end: {
            line: 386,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 386,
            column: 38
          },
          end: {
            line: 386,
            column: 40
          }
        }, {
          start: {
            line: 386,
            column: 43
          },
          end: {
            line: 386,
            column: 52
          }
        }],
        line: 386
      },
      "35": {
        loc: {
          start: {
            line: 387,
            column: 23
          },
          end: {
            line: 387,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 23
          },
          end: {
            line: 387,
            column: 34
          }
        }, {
          start: {
            line: 387,
            column: 38
          },
          end: {
            line: 387,
            column: 54
          }
        }],
        line: 387
      },
      "36": {
        loc: {
          start: {
            line: 393,
            column: 9
          },
          end: {
            line: 393,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 393,
            column: 9
          },
          end: {
            line: 393,
            column: 21
          }
        }, {
          start: {
            line: 393,
            column: 25
          },
          end: {
            line: 393,
            column: 39
          }
        }, {
          start: {
            line: 393,
            column: 43
          },
          end: {
            line: 393,
            column: 81
          }
        }],
        line: 393
      },
      "37": {
        loc: {
          start: {
            line: 394,
            column: 9
          },
          end: {
            line: 394,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 394,
            column: 9
          },
          end: {
            line: 394,
            column: 19
          }
        }, {
          start: {
            line: 394,
            column: 23
          },
          end: {
            line: 394,
            column: 56
          }
        }],
        line: 394
      },
      "38": {
        loc: {
          start: {
            line: 395,
            column: 9
          },
          end: {
            line: 397,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 395,
            column: 9
          },
          end: {
            line: 395,
            column: 19
          }
        }, {
          start: {
            line: 396,
            column: 10
          },
          end: {
            line: 396,
            column: 98
          }
        }],
        line: 395
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0, 0],
      "14": [0, 0, 0, 0, 0, 0],
      "15": [0, 0],
      "16": [0, 0, 0, 0, 0, 0, 0],
      "17": [0, 0, 0, 0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0],
      "23": [0, 0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0, 0],
      "37": [0, 0],
      "38": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7597c3fd6986d867cfc66edf73785ba8987d9044"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ndg0d3lom = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_ndg0d3lom();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import InputBase from './InputBase';
import Label from '../Label';
import { Text, Flex } from '../index';
import { ErrorPrompt } from '../../complex/ErrorPrompt';
import { checkEmailValidity, checkNumberValidity, checkTelValidity, formatValue, unformatValue, sanitizeAndFormatNumberWithCommas } from '../../core/Input/helpers';
var ASSERT_NOT_NULL_ERROR = (cov_ndg0d3lom().s[0]++, 'This field cannot be empty.');
cov_ndg0d3lom().s[1]++;
export var Input = function Input(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? (cov_ndg0d3lom().b[0][0]++, 's1') : _ref$fontSize,
      label = _ref.label,
      subtitle = _ref.subtitle,
      errorMessageProp = _ref.errorMessage,
      isInvalid = _ref.invalid,
      initialDecimalPlaces = _ref.decimalPlaces,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? (cov_ndg0d3lom().b[1][0]++, 100) : _ref$delay,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? (cov_ndg0d3lom().b[2][0]++, 'text') : _ref$type,
      _ref$unboundedWidth = _ref.unboundedWidth,
      unboundedWidth = _ref$unboundedWidth === void 0 ? (cov_ndg0d3lom().b[3][0]++, false) : _ref$unboundedWidth,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? (cov_ndg0d3lom().b[4][0]++, 'vertical') : _ref$orientation,
      min = _ref.min,
      max = _ref.max,
      customEmailValidityCheck = _ref.customEmailValidityCheck,
      labelStyles = _ref.labelStyles,
      disabled = _ref.disabled,
      helperText = _ref.helperText,
      maxLength = _ref.maxLength,
      required = _ref.required,
      placeholder = _ref.placeholder,
      analyticsName = _ref.analyticsName,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_ndg0d3lom().f[0]++;
  var decimalPlaces = (cov_ndg0d3lom().s[2]++, (cov_ndg0d3lom().b[6][0]++, initialDecimalPlaces) && (cov_ndg0d3lom().b[6][1]++, initialDecimalPlaces >= 0) ? (cov_ndg0d3lom().b[5][0]++, initialDecimalPlaces) : (cov_ndg0d3lom().b[5][1]++, 0));

  var _ref2 = (cov_ndg0d3lom().s[3]++, React.useState(value ? (cov_ndg0d3lom().b[7][0]++, formatValue(value, type, decimalPlaces)) : (cov_ndg0d3lom().b[7][1]++, ''))),
      _ref3 = _slicedToArray(_ref2, 2),
      content = _ref3[0],
      updateContent = _ref3[1];

  var _ref4 = (cov_ndg0d3lom().s[4]++, React.useState()),
      _ref5 = _slicedToArray(_ref4, 2),
      cursorPosition = _ref5[0],
      setCursorPosition = _ref5[1];

  var _ref6 = (cov_ndg0d3lom().s[5]++, React.useState(content)),
      _ref7 = _slicedToArray(_ref6, 2),
      setPreviousContent = _ref7[1];

  var _ref8 = (cov_ndg0d3lom().s[6]++, React.useState()),
      _ref9 = _slicedToArray(_ref8, 2),
      suggestion = _ref9[0],
      setSuggestion = _ref9[1];

  var _ref10 = (cov_ndg0d3lom().s[7]++, React.useState(!!isInvalid)),
      _ref11 = _slicedToArray(_ref10, 2),
      invalid = _ref11[0],
      setInvalid = _ref11[1];

  var _ref12 = (cov_ndg0d3lom().s[8]++, React.useState(false)),
      _ref13 = _slicedToArray(_ref12, 2),
      hasInteracted = _ref13[0],
      setHasInteracted = _ref13[1];

  var _ref14 = (cov_ndg0d3lom().s[9]++, useDebouncedCallback( /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, val) {
      var unformattedValue, _ref17, valid, _suggestion;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cov_ndg0d3lom().f[1]++;
              cov_ndg0d3lom().s[10]++;

              if (!onChange) {
                _context.next = 19;
                break;
              }

              cov_ndg0d3lom().b[8][0]++;
              unformattedValue = (cov_ndg0d3lom().s[11]++, unformatValue(val, type));
              cov_ndg0d3lom().s[12]++;
              _context.next = 8;
              return checkValidity(val);

            case 8:
              _ref17 = _context.sent;
              valid = _ref17.valid;
              _suggestion = _ref17.suggestion;
              cov_ndg0d3lom().s[13]++;
              setInvalid(!valid);
              cov_ndg0d3lom().s[14]++;
              setSuggestion(_suggestion);
              cov_ndg0d3lom().s[15]++;
              onChange(e, unformattedValue, valid);
              _context.next = 20;
              break;

            case 19:
              cov_ndg0d3lom().b[8][1]++;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref16.apply(this, arguments);
    };
  }(), delay)),
      _ref15 = _slicedToArray(_ref14, 1),
      debouncedOnChange = _ref15[0];

  var inputRef = (cov_ndg0d3lom().s[16]++, React.useRef());
  var checkEmail = (cov_ndg0d3lom().s[17]++, customEmailValidityCheck ? (cov_ndg0d3lom().b[9][0]++, customEmailValidityCheck) : (cov_ndg0d3lom().b[9][1]++, checkEmailValidity));
  var errorMessage = (cov_ndg0d3lom().s[18]++, (cov_ndg0d3lom().b[11][0]++, required) && (cov_ndg0d3lom().b[11][1]++, _isEmpty(content)) ? (cov_ndg0d3lom().b[10][0]++, ASSERT_NOT_NULL_ERROR) : (cov_ndg0d3lom().b[10][1]++, errorMessageProp));
  var isHorizontalOrientation = (cov_ndg0d3lom().s[19]++, orientation === 'horizontal');
  cov_ndg0d3lom().s[20]++;

  var useSuggestion = function useSuggestion() {
    cov_ndg0d3lom().f[2]++;
    cov_ndg0d3lom().s[21]++;
    updateContent(suggestion);
    cov_ndg0d3lom().s[22]++;
    debouncedOnChange(undefined, suggestion);
    cov_ndg0d3lom().s[23]++;
    setSuggestion(undefined);
  };

  cov_ndg0d3lom().s[24]++;

  var checkValidity = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newValue) {
      var valid, suggestion, emailValidityResult;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cov_ndg0d3lom().f[3]++;
              valid = (cov_ndg0d3lom().s[25]++, true);
              suggestion = (cov_ndg0d3lom().s[26]++, '');
              cov_ndg0d3lom().s[27]++;

              if (newValue) {
                _context2.next = 10;
                break;
              }

              cov_ndg0d3lom().b[12][0]++;
              cov_ndg0d3lom().s[28]++;
              valid = !required;
              _context2.next = 37;
              break;

            case 10:
              cov_ndg0d3lom().b[12][1]++;
              cov_ndg0d3lom().s[29]++;
              _context2.t0 = type;
              _context2.next = _context2.t0 === 'email' ? 15 : _context2.t0 === 'tel' ? 26 : _context2.t0 === 'number' ? 31 : 36;
              break;

            case 15:
              cov_ndg0d3lom().b[13][0]++;
              cov_ndg0d3lom().s[30]++;
              _context2.next = 19;
              return checkEmail(newValue);

            case 19:
              emailValidityResult = _context2.sent;
              cov_ndg0d3lom().s[31]++;
              valid = emailValidityResult.valid;
              cov_ndg0d3lom().s[32]++;
              suggestion = emailValidityResult.suggestion;
              cov_ndg0d3lom().s[33]++;
              return _context2.abrupt("break", 37);

            case 26:
              cov_ndg0d3lom().b[13][1]++;
              cov_ndg0d3lom().s[34]++;
              valid = checkTelValidity(newValue);
              cov_ndg0d3lom().s[35]++;
              return _context2.abrupt("break", 37);

            case 31:
              cov_ndg0d3lom().b[13][2]++;
              cov_ndg0d3lom().s[36]++;
              valid = checkNumberValidity(newValue, min, max);
              cov_ndg0d3lom().s[37]++;
              return _context2.abrupt("break", 37);

            case 36:
              cov_ndg0d3lom().b[13][3]++;

            case 37:
              cov_ndg0d3lom().s[38]++;
              return _context2.abrupt("return", {
                valid: valid,
                suggestion: suggestion
              });

            case 39:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function checkValidity(_x3) {
      return _ref18.apply(this, arguments);
    };
  }(); // we are using a string to store the input value (even for percent, number, currency) since we have a need to display commas


  cov_ndg0d3lom().s[39]++;

  var getInputMode = function getInputMode() {
    cov_ndg0d3lom().f[4]++;
    cov_ndg0d3lom().s[40]++;

    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[14][0]++;
        cov_ndg0d3lom().s[41]++;
        return 'email';

      case 'tel':
        cov_ndg0d3lom().b[14][1]++;
        cov_ndg0d3lom().s[42]++;
        return 'tel';

      case 'percent':
        cov_ndg0d3lom().b[14][2]++;

      case 'number':
        cov_ndg0d3lom().b[14][3]++;

      case 'currency':
        cov_ndg0d3lom().b[14][4]++;
        cov_ndg0d3lom().s[43]++;
        return decimalPlaces > 0 ? (cov_ndg0d3lom().b[15][0]++, 'decimal') : (cov_ndg0d3lom().b[15][1]++, 'numeric');

      default:
        cov_ndg0d3lom().b[14][5]++;
        cov_ndg0d3lom().s[44]++;
        return 'text';
    }
  };

  cov_ndg0d3lom().s[45]++;

  var getType = function getType() {
    cov_ndg0d3lom().f[5]++;
    cov_ndg0d3lom().s[46]++;

    switch (type) {
      case 'password':
        cov_ndg0d3lom().b[16][0]++;
        cov_ndg0d3lom().s[47]++;
        return 'password';

      case 'email':
        cov_ndg0d3lom().b[16][1]++;
        cov_ndg0d3lom().s[48]++;
        return 'email';

      case 'tel':
        cov_ndg0d3lom().b[16][2]++;
        cov_ndg0d3lom().s[49]++;
        return 'tel';

      case 'percent':
        cov_ndg0d3lom().b[16][3]++;
        cov_ndg0d3lom().s[50]++;
        // NOTE: Number inputs intentionally have the input type of 'text'
        // to allow for formatting with commas
        return 'text';

      case 'number':
        cov_ndg0d3lom().b[16][4]++;
        cov_ndg0d3lom().s[51]++;
        // NOTE: Number inputs intentionally have the input type of 'text'
        // to allow for formatting with commas
        return 'text';

      case 'currency':
        cov_ndg0d3lom().b[16][5]++;
        cov_ndg0d3lom().s[52]++;
        // NOTE: Currency inputs intentionally have the input type of 'text'
        // to allow for formatting with commas and $
        return 'text';

      default:
        cov_ndg0d3lom().b[16][6]++;
        cov_ndg0d3lom().s[53]++;
        return 'text';
    }
  };

  cov_ndg0d3lom().s[54]++;

  var getPlaceholder = function getPlaceholder() {
    cov_ndg0d3lom().f[6]++;
    cov_ndg0d3lom().s[55]++;

    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[17][0]++;
        cov_ndg0d3lom().s[56]++;
        return 'you@example.com';

      case 'tel':
        cov_ndg0d3lom().b[17][1]++;
        cov_ndg0d3lom().s[57]++;
        return '(000) 000-0000';

      case 'currency':
        cov_ndg0d3lom().b[17][2]++;
        cov_ndg0d3lom().s[58]++;
        return '$0.00';

      case 'percent':
        cov_ndg0d3lom().b[17][3]++;
        cov_ndg0d3lom().s[59]++;
        return '0.00%';

      default:
        cov_ndg0d3lom().b[17][4]++;
        cov_ndg0d3lom().s[60]++;
        return '';
    }
  };

  cov_ndg0d3lom().s[61]++;

  var getAutoCompleteAttribute = function getAutoCompleteAttribute() {
    cov_ndg0d3lom().f[7]++;
    cov_ndg0d3lom().s[62]++;

    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[18][0]++;
        cov_ndg0d3lom().s[63]++;
        return 'email';

      case 'tel':
        cov_ndg0d3lom().b[18][1]++;
        cov_ndg0d3lom().s[64]++;
        return 'tel';

      default:
        cov_ndg0d3lom().b[18][2]++;
        cov_ndg0d3lom().s[65]++;
        return undefined;
    }
  };
  /*
    Manually set the cursor position for number/currency inputs. Without this, the cursor
    will always jump to the end of the input string when we add or remove commas.
  */


  cov_ndg0d3lom().s[66]++;
  useEffect(function () {
    cov_ndg0d3lom().f[8]++;
    cov_ndg0d3lom().s[67]++;

    if ((cov_ndg0d3lom().b[20][0]++, inputRef.current) && (cov_ndg0d3lom().b[20][1]++, cursorPosition !== undefined)) {
      cov_ndg0d3lom().b[19][0]++;
      cov_ndg0d3lom().s[68]++;
      inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
    } else {
      cov_ndg0d3lom().b[19][1]++;
    }
  }, [cursorPosition]);
  cov_ndg0d3lom().s[69]++;

  var updateNumericContent = function updateNumericContent(value, selectionStart) {
    cov_ndg0d3lom().f[9]++;
    var formatted = (cov_ndg0d3lom().s[70]++, sanitizeAndFormatNumberWithCommas(value));
    var changeInLength = (cov_ndg0d3lom().s[71]++, formatted.length - value.length);
    var newCursorPosition = (cov_ndg0d3lom().s[72]++, selectionStart + changeInLength);
    cov_ndg0d3lom().s[73]++;
    setCursorPosition(newCursorPosition > 0 ? (cov_ndg0d3lom().b[21][0]++, newCursorPosition) : (cov_ndg0d3lom().b[21][1]++, 0));
    cov_ndg0d3lom().s[74]++;
    updateContent(formatted);
  };

  cov_ndg0d3lom().s[75]++;

  var handleChange = function handleChange(e) {
    cov_ndg0d3lom().f[10]++;
    cov_ndg0d3lom().s[76]++;
    e.preventDefault();
    cov_ndg0d3lom().s[77]++;
    setHasInteracted(true);
    cov_ndg0d3lom().s[78]++;
    debouncedOnChange(e, e.currentTarget.value);
    cov_ndg0d3lom().s[79]++;
    setPreviousContent(content);
    cov_ndg0d3lom().s[80]++;

    switch (type) {
      case 'number':
        cov_ndg0d3lom().b[22][0]++;

      case 'currency':
        cov_ndg0d3lom().b[22][1]++;
        cov_ndg0d3lom().s[81]++;
        updateNumericContent(e.currentTarget.value, e.currentTarget.selectionStart);
        cov_ndg0d3lom().s[82]++;
        break;

      default:
        cov_ndg0d3lom().b[22][2]++;
        cov_ndg0d3lom().s[83]++;
        updateContent(e.currentTarget.value);
    }
  };

  cov_ndg0d3lom().s[84]++;

  var handleBlur = function handleBlur() {
    cov_ndg0d3lom().f[11]++;
    cov_ndg0d3lom().s[85]++;
    setHasInteracted(true);
    cov_ndg0d3lom().s[86]++;
    updateContent(formatValue(content, type, decimalPlaces));
  }; // An empty required input should only be shown as invalid after the user has interacted with it


  var displayInvalid = (cov_ndg0d3lom().s[87]++, (cov_ndg0d3lom().b[23][0]++, required) && (cov_ndg0d3lom().b[23][1]++, _isEmpty(content)) && (cov_ndg0d3lom().b[23][2]++, hasInteracted) || (cov_ndg0d3lom().b[23][3]++, invalid));
  cov_ndg0d3lom().s[88]++;
  return /*#__PURE__*/React.createElement(Flex, {
    className: "input-container",
    flexDirection: isHorizontalOrientation ? (cov_ndg0d3lom().b[24][0]++, 'row') : (cov_ndg0d3lom().b[24][1]++, 'column'),
    alignItems: isHorizontalOrientation ? (cov_ndg0d3lom().b[25][0]++, 'center') : (cov_ndg0d3lom().b[25][1]++, ''),
    width: ['100%', null, unboundedWidth ? (cov_ndg0d3lom().b[26][0]++, '100%') : (cov_ndg0d3lom().b[26][1]++, '350px')]
  }, ((cov_ndg0d3lom().b[27][0]++, label) || (cov_ndg0d3lom().b[27][1]++, subtitle)) && (cov_ndg0d3lom().b[27][2]++, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    pr: isHorizontalOrientation ? (cov_ndg0d3lom().b[28][0]++, [3, 4]) : (cov_ndg0d3lom().b[28][1]++, []),
    pb: isHorizontalOrientation ? (cov_ndg0d3lom().b[29][0]++, []) : (cov_ndg0d3lom().b[29][1]++, [2, 3])
  }, (cov_ndg0d3lom().b[30][0]++, label) && (cov_ndg0d3lom().b[30][1]++, /*#__PURE__*/React.createElement(Label, _extends({
    htmlFor: props.id,
    fontSize: fontSize,
    required: required,
    color: disabled ? (cov_ndg0d3lom().b[31][0]++, 'neutrals70') : (cov_ndg0d3lom().b[31][1]++, undefined)
  }, labelStyles), label)), (cov_ndg0d3lom().b[32][0]++, subtitle) && (cov_ndg0d3lom().b[32][1]++, /*#__PURE__*/React.createElement(Flex, {
    pt: 3
  }, /*#__PURE__*/React.createElement(Subtitle, {
    color: disabled ? (cov_ndg0d3lom().b[33][0]++, 'neutrals70') : (cov_ndg0d3lom().b[33][1]++, 'neutrals100')
  }, subtitle))))), /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(InputBase, _extends({
    analyticsName: analyticsName,
    "aria-disabled": disabled,
    "aria-required": required,
    "aria-invalid": displayInvalid,
    autoComplete: getAutoCompleteAttribute(),
    ref: inputRef,
    required: required,
    fontSize: fontSize,
    onChange: handleChange,
    value: content,
    type: getType(),
    inputMode: getInputMode(),
    maxLength: type === 'tel' ? (cov_ndg0d3lom().b[34][0]++, 16) : (cov_ndg0d3lom().b[34][1]++, maxLength),
    placeholder: (cov_ndg0d3lom().b[35][0]++, placeholder) || (cov_ndg0d3lom().b[35][1]++, getPlaceholder()),
    onBlur: handleBlur,
    disabled: disabled
  }, props)), (cov_ndg0d3lom().b[36][0]++, errorMessage) && (cov_ndg0d3lom().b[36][1]++, displayInvalid) && (cov_ndg0d3lom().b[36][2]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
    message: errorMessage
  })), (cov_ndg0d3lom().b[37][0]++, helperText) && (cov_ndg0d3lom().b[37][1]++, /*#__PURE__*/React.createElement(HelpText, null, helperText)), (cov_ndg0d3lom().b[38][0]++, suggestion) && (cov_ndg0d3lom().b[38][1]++, /*#__PURE__*/React.createElement(Suggestion, {
    suggestion: suggestion,
    useSuggestion: useSuggestion,
    fontSize: fontSize
  }))));
};
cov_ndg0d3lom().s[89]++;

var Subtitle = function Subtitle(props) {
  cov_ndg0d3lom().f[12]++;
  cov_ndg0d3lom().s[90]++;
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontWeight: "normal",
    fontSize: "s0",
    textAlign: "left",
    lineHeight: 1
  }, props));
};

cov_ndg0d3lom().s[91]++;

var HelpText = function HelpText(props) {
  cov_ndg0d3lom().f[13]++;
  cov_ndg0d3lom().s[92]++;
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, props));
};

cov_ndg0d3lom().s[93]++;
export var Suggestion = function Suggestion(_ref19) {
  var suggestion = _ref19.suggestion,
      useSuggestion = _ref19.useSuggestion,
      props = _objectWithoutProperties(_ref19, _excluded2);

  cov_ndg0d3lom().f[14]++;
  cov_ndg0d3lom().s[94]++;
  return /*#__PURE__*/React.createElement(Text, _extends({
    id: "input-suggestion",
    mt: 3,
    color: "brand50",
    cursor: "pointer",
    fontFamily: "sans",
    onClick: useSuggestion
  }, props), "Did you mean \"", suggestion, "\"?");
};
export default Input;